import { theme } from '@clickcease/cc-client-components-lib'
import { Options } from 'highcharts'

export const defaultPieOptions: Options = {
  legend: {
    symbolHeight: 14,
    symbolWidth: 14,
    itemMarginBottom: 12,
    itemHoverStyle: { cursor: 'pointer' },
    alignColumns: false,
    itemStyle: {
      color: theme.colors.black.value,
      fontSize: theme.fontSizes.md.value,
      fontWeight: theme.fontWeights.l.value,
    },
    align: 'center',
    verticalAlign: 'bottom',
    symbolRadius: 2,
    useHTML: true,
    labelFormatter: function () {
      const { name, y, percentage } = this as {
        name: string
        y: number
        percentage: number
      }
      return `<span>${name} <b>${y} (${percentage.toFixed(1)}%)</b> </span>`
    },
  },
  chart: {
    type: 'pie',
    height: null,
  },
  tooltip: {
    enabled: true,
    outside: false,
    useHTML: true,
    style: {
      zIndex: 100,
    },
  },
}
